import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useShop = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.SHOP(),
    queryFn: () => shopApi.fetchShop(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.SHOP(),
    });
  };

  return {
    isLoading,
    isFetching,
    shop: data?.data,
    invalidate,
  };
};
